var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOptionMaster = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zm-2 1h-3V9h4v5a1 1 0 0 1-1 1m1-7V5h-4v3zm0-4V2a1 1 0 0 0-1-1h-3v3zm-5-3H6v14h4zM5 7H1V2a1 1 0 0 1 1-1h3zm-4 4V8h4v3zm0 3v-2h4v3H2a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgOptionMaster;